enum Status {
  ACTIVE = "active",
  IN_ACTIVE = "in_active",
  PENDING = "pending",
  APPROVED = "approved",
}

export default Status;
